import { createContext, useContext, useEffect, useState } from 'react';
import { IconSun, IconMoon, IconDeviceDesktop } from '@tabler/icons-react';
import { useTheme } from '@/components/providers/theme-provider';

/** True on marketing pages that have a dark design; the header shows the theme switch only there. */
export const ThemedContext = createContext(false);
export const useThemedPage = () => useContext(ThemedContext);

const OPTIONS = [
  { value: 'light', label: 'Light', icon: IconSun },
  { value: 'dark', label: 'Dark', icon: IconMoon },
  { value: 'system', label: 'System', icon: IconDeviceDesktop },
] as const;

/** Sun / moon / system segmented control. Default is system. */
export function ThemeSwitch({ className = '' }: { className?: string }) {
  const { theme, setTheme } = useTheme();
  // Prerendered HTML always says "System"; show the stored choice only after hydration so the two match.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  const current = mounted ? theme : 'system';
  return (
    <div className={`theme-switch ${className}`} role="group" aria-label="Colour theme">
      {OPTIONS.map(({ value, label, icon: Icon }) => (
        <button key={value} type="button" aria-pressed={current === value} aria-label={label} title={label} onClick={() => setTheme(value)}>
          <Icon size={16} stroke={1.5} />
        </button>
      ))}
    </div>
  );
}
